import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Custom marker icon
const customIcon = L.divIcon({
  className: "",
  html: `<div class="custom-marker"><div class="custom-marker-inner">+</div></div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 30],
});

const userIcon = L.divIcon({
  className: "",
  html: `<div style="width:18px;height:18px;border-radius:50%;background:#B4654A;border:3px solid #fff;box-shadow:0 0 0 2px #B4654A55"></div>`,
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

function Recenter({ center }) {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, map.getZoom() || 12);
  }, [center, map]);
  return null;
}

export default function MapView({ center = [48.8566, 2.3522], doctors = [], userPos, onSelect }) {
  return (
    <div className="w-full h-full rounded-xl overflow-hidden border border-slate-200">
      <MapContainer center={center} zoom={12} className="w-full h-full" style={{ minHeight: 400 }} scrollWheelZoom>
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Recenter center={center} />
        {userPos && (
          <Marker position={userPos} icon={userIcon}>
            <Popup>Vous êtes ici</Popup>
          </Marker>
        )}
        {doctors.filter((d) => d.lat && d.lng).map((d) => (
          <Marker key={d.user_id} position={[d.lat, d.lng]} icon={customIcon} eventHandlers={{ click: () => onSelect && onSelect(d) }}>
            <Popup>
              <div className="font-display font-semibold">{d.name}</div>
              <div className="text-xs text-slate-600">{d.specialty}</div>
              <div className="text-xs text-slate-500 mt-1">{d.address}</div>
              {d.available_slots_14d > 0 && (
                <div className="text-xs text-emerald-700 mt-1 font-medium">{d.available_slots_14d} créneaux disponibles</div>
              )}
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
